function TeamNamePanel() {
}

TeamNamePanel.configuration = {
    perspective: "front",
    side: undefined
};

TeamNamePanel.TEAM_NAME_TYPE = "team_name";

TeamNamePanel.LAYER_NAME_MASK = "Mask";
TeamNamePanel.LAYER_NAME_PSEUDO_SHADOW = "Pseudo Shadow";
TeamNamePanel.TAIL_SWEEP_NONE = "none";

TeamNamePanel.updateTailSweepColorLayer = function(code, layer_number, colorObj) {
    var app = _.find(ub.current_material.settings.applications, {code: code.toString()});

    if (app !== undefined) {
        if (app.tailSweepColorSyncLayers !== undefined) {
            var tailSweepColorLayer = _.find(app.tailSweepColorSyncLayers, {layer_number: layer_number});

            if (tailSweepColorLayer !== undefined) {
                tailSweepColorLayer.color_obj = colorObj;
            }
        }
    }
};

TeamNamePanel.updateTailSweepColorLayers = function(code) {
    var app = _.find(ub.current_material.settings.applications, {code: code.toString()});

    if (app !== undefined) {
        if (app.accent_obj !== undefined && app.tailSweepColorSyncLayers !== undefined) {
            var accentObjLayers = _.filter(app.accent_obj.layers, function(layer) {
                return layer.name !== TeamNamePanel.LAYER_NAME_MASK && layer.name !== TeamNamePanel.LAYER_NAME_PSEUDO_SHADOW;
            });

            app.tailSweepColorSyncLayers = [];

            _.each(accentObjLayers, function(layer, index) {
                app.tailSweepColorSyncLayers[index] = {
                    layer_number: layer.layer_no,
                    layer_name: layer.name,
                    color_obj: ub.funcs.getColorObjByHexCode(layer.default_color)
                };
            });
        }
    }
};

TeamNamePanel.configurationSocks = {
    perspective: "left",
    side: undefined
}

TeamNamePanel.events = {
    isInit: true,
    reloadTextShape: true,

    init: function() {
        var that = this;

        if (that.isInit) {
            // Add Team Name
            $(".modifier_main_container").on("click", ".team-name-panel .add-team-name .btn-selection-choice", that.onClickAddTeamName);
            // Change Color of Team anme
            $('.modifier_main_container').on('click', '.team-name-panel .teamOptionContainer .colorItem[data-object-type="accent"]', that.onChangeAccentColor);
            // Change Team name accent
            $('.modifier_main_container').on('click', '.team-name-panel .m-accents .btn-selection-choice', that.onSelectFontAccent);
            // Change team name font
            $('.modifier_main_container').on('click', '.team-name-panel .teamOptionContainer a.change-font-style', that.onChangeFontStyle);
            // Change team name layout
            $('.modifier_main_container').on('click', '.team-name-panel .teamOptionContainer a.change-team-name-layout', that.onChangeTeamNameLayout);
            // Open team Layout Modal
            $('.modifier_main_container').on('click', '.team-name-panel .teamOptionContainer a.select-team-name-layout', that.onSelectTeamNameLayout);
            // Open team font modal
            $(".modifier_main_container").on('click', '.team-name-panel .select-font-style', that.onCreateFontPopUp);
            // Change text on Keypress
            $(".modifier_main_container").on('keyup keypress', '.team-name-panel input.app-letters-input', that.onKeyPressApplicationText);
            // Change text on focus out
            $(".modifier_main_container").on('focusout', '.team-name-panel input.app-letters-input', that.onLeaveTeamNameText);
            // Remove Team name
            $('.modifier_main_container').on('click', '.team-name-panel a.remove-team-name', that.onRemoveTeamName);
            // View all application
            $('.modifier_main_container').on('click', '.team-name-panel .view-all-application', that.onViewAllDecoration);
            // On Change Tail sweep.
            $('.modifier_main_container').on('click', '.team-name-panel .tail-sweep-container .tail-sweep-button', that.onSelectTailSweep);

            that.isInit = false;

            // activate front perspective
            $('#left-side-toolbar > div > div > a[data-perspective="front"]').click();
        }

        var teamNameObj = _.find(ub.current_material.settings.applications, {type: "team_name"});
        var customTeamNameObj = _.find(ub.current_material.settings.applications, {logo_type: "custom_text"});
        var textShapeObj = TextShapeCore.utilities.findTextShape(TeamNamePanel.TEAM_NAME_TYPE);

        if (typeof teamNameObj !== "undefined") {
            TeamNamePanel.funcs.initializeTeamName(teamNameObj.code);
        } else if (typeof customTeamNameObj !== "undefined") {
            TeamNamePanel.funcs.initializeTeamName(customTeamNameObj.code);
        } else if (textShapeObj) {
            //  Reload Text if saved design have text shape
            if (typeof ub.config.savedDesignInfo === "object") {
                if (that.reloadTextShape) {
                    TextShapeCore.textShape.reload(textShapeObj.code);
                    that.reloadTextShape = false;
                }
            }
            TeamNamePanel.funcs.initializeTeamName(textShapeObj.code);
        } else {
            TeamNamePanel.funcs.loadAddTeamName();
        }

        // fix accent object colors not same in color array
        TeamNamePanel.funcs.mapColorsToAccentObj();
    },

    onViewAllDecoration: function() {
        ub.funcs.deactivateMoveTool();
        ApplicationList.events.init();
    },

    onClickAddTeamName: function() {
        var type = $(this).data("type");
        var no_alert = $(this).data("no-alert");
        TeamNamePanel.funcs.newTeamName(type, no_alert);
    },

    onChangeAccentColor: function() {
        // changing active color
        $(this).parent().parent().find('button').removeClass('activeColorItem').html('');
        $(this).addClass('activeColorItem').html('<span class="fa fa-check fa-1x cp-margin-remove cp-padding-remove cp-check-color-font-size"></span>');
        // Get data
        var _layer_name = $(this).data('layer-name');
        var _color_code = $(this).data('color-code');
        var _layer_no = $(this).data('layer-no');
        var code = $(this).attr('data-id');
        var color = $(this).data('color');
        // Get Settings
        var _colorObj = ub.funcs.getColorByColorCode(_color_code);
        var _settingsObject = ub.funcs.getApplicationSettings(code);

        if (TextShapeCore.utilities.isTextShape(_settingsObject.code)) {
            if (_settingsObject.text_shape_type === "arc") {
                TextShapeCore.customControllers.changeArcColor(_settingsObject, _layer_name, _layer_no, _colorObj)
            } else {
                TextShapeCore.canvas.changeColor(_settingsObject, _layer_name, _layer_no, _colorObj);
            }

            TeamNamePanel.updateTailSweepColorLayer(code, _layer_no, _colorObj);
        } else {
            ApplicationCore.controllers.changeTextApplicationColor(_settingsObject, _layer_name, _layer_no, _colorObj);
        }

       TailSweep.funcs.changeTailSweepColor(_layer_name, _colorObj, _settingsObject);
    },

    onSelectFontAccent: function() {
        if ($(this).hasClass("uk-active")) {
            return;
        }

        var code = $(this).closest(".teamOptionContainer").data("code");
        var accentID = $(this).data('accent-id');
        var accentCode = $(this).data('accent-code');
        var settingsObj = ub.funcs.getApplicationSettings(code);

        if (TextShapeCore.utilities.isTextShape(settingsObj.code)) {
            if (settingsObj.text_shape_type === "arc") {
                TextShapeCore.customControllers.renderTextShapeAccent(settingsObj, accentID);
            } else {
                TextShapeCore.canvas.changeAccent(accentID, settingsObj);
            }
        } else {
            ApplicationCore.controllers.changeTextApplicationAccent(accentID, settingsObj);
        }

        // TailSweep Configuration
        TeamNamePanel.updateTailSweepColorLayers(code);
        TailSweep.funcs.changeUpdateTailSweepAccent(settingsObj, accentCode);
        TailSweep.funcs.hideShowTailSweep(accentCode);

        // Re initialize team name application to refresh the side panel UI
        TeamNamePanel.funcs.initializeTeamName(code);
        _.delay(function() {
            $("#primary_options_container").scrollTo($(".teamOptionContainer .con-select.con-palettes"), {duration: 300});
        }, 100);
    },

    onChangeFontStyle: function() {
        var direction = $(this).data("direction");
        var code = $(this).closest(".teamOptionContainer").data("code");
        var app = ub.funcs.getApplicationSettings(code);

        if (TextShapeCore.utilities.isTextShape(code)) {
            if (app.text_shape_type === "arc") {
                TextShapeCore.customControllers.changeTextArcFontStyle(code, direction);
            } else {
                TextShapeCore.canvas.changeFont(app.code, direction);
            }
        } else {
            ApplicationCore.controllers.changeTextApplicationFontStyle(code, direction);
        }
    },

    onChangeTeamNameLayout: function() {
        var direction = $(this).data("direction");
        var code = $(this).closest(".teamOptionContainer").data("code");
        var layout_container_el = $('#team-name-layout-container');
        var team_name_layout_el = $('.select-team-name-layout .team-name-layout', layout_container_el);
        var current_team_layout = team_name_layout_el.data("team-name-layout");
        var application = ub.funcs.getApplicationSettings(code);
        var textShapes = ub.data.textShapes.items;

        var current_type_key = textShapes.indexOf(current_team_layout);

        switch(direction) {
            case TextShapeCore.TEXT_SHAPE_LAYOUT_NEXT_TEXT:
                current_type_key++;
                break;

            case TextShapeCore.TEXT_SHAPE_LAYOUT_PREVIOUS_TEXT:
                current_type_key--;
                break;
        }

        if (current_type_key < 0) {
            current_type_key = 0;
        } else if (current_type_key > (textShapes.length-1)) {
            current_type_key = textShapes-1;
        } else {
            var new_layout = textShapes[current_type_key];
            TeamNamePanel.funcs.changeTeamLayout(new_layout, application);
        }
    },

    onSelectTeamNameLayout: function() {
        var current_layout = $('.team-name-layout', $(this)).data("team-name-layout");
        var code = $(this).closest(".teamOptionContainer").data("code");
        var application = ub.funcs.getApplicationSettings(code);
        var type = TeamNamePanel.TEAM_NAME_TYPE.replace("_", " ");

        // Open Text shape layout modal
        TextShapeCore.utilities.openTextLayoutModal(code, type, current_layout, TeamNamePanel.TEAM_NAME_TYPE);
    },

    onRemoveTeamName: function() {
        var code = $(this).data("code");
        var _application = ub.funcs.getApplicationSettings(code);
        var tailSweep = TailSweep.funcs.getTailSweepSettings(code.toString());

        UIkit.modal.confirm('Are you sure you want to delete Team Name #' + _application.code + '?').then(function() {
            if (typeof tailSweep !== "undefined") {
                ub.funcs.deleteLocation(tailSweep.code);
            }

            if (typeof _application !== "undefined") {
                ub.funcs.deleteLocation(_application.code);
            }

            var teamNameObj = _.find(ub.current_material.settings.applications, {type: "team_name"});
            var customTeamNameObj = _.find(ub.current_material.settings.applications, {logo_type: "custom_text"});
            var textShapeObj = TextShapeCore.utilities.getTextShape(code);

            if (typeof teamNameObj !== "undefined") {
                TeamNamePanel.funcs.initializeTeamName(teamNameObj.code);
            } else if (typeof customTeamNameObj !== "undefined") {
                TeamNamePanel.funcs.initializeTeamName(customTeamNameObj.code);
            } else if (textShapeObj) {
                TeamNamePanel.funcs.initializeTeamName(textShapeObj.code);
            } else {
                TeamNamePanel.funcs.loadAddTeamName();
            }

            // add flag that show alert message when creating application
            $('.btn-selection-choice[data-type="'+TeamNamePanel.TEAM_NAME_TYPE+'"]').data('no-alert', false);
        }, function () {
        });
    },

    onCreateFontPopUp: function() {
        var app_code = $(this).data('application-code');
        var application = ub.funcs.getApplicationSettings(app_code);

        var sample_text = $(".modifier_main_container #team-name-panel input.app-letters-input").val();

        if (_.isEmpty(sample_text)) {
            sample_text = "Sample Text";
        }

        if (typeof application !== "undefined") {
            ApplicationCore.utilities.openFontModal(sample_text, application);
        }
    },

    onKeyPressApplicationText: function(e) {
        var ENTER = 13;
        var input = $(this).val();
        var id = $(this).closest('#team-name-panel').data("code").toString();
        var _settingsObject = ub.funcs.getApplicationSettings(id);

        if (input.length >= 13) {
            $(this).addClass("uk-form-warning");
            TeamNamePanel.funcs.addInputTextMessage("Maximum of 13 characters");
        } else if (input.length === 0) {
            $(this).addClass("uk-form-warning");
            TeamNamePanel.funcs.addInputTextMessage("This text field is required.");
            return;
        } else {
            $(this).removeClass("uk-form-warning");
            $(".team-name-helper-message").addClass("uk-hidden");
        }

        if (e.keyCode === ENTER) {
            if (TextShapeCore.utilities.isTextShape(id)) {
                if (_settingsObject.text_shape_type === "arc") {
                    TextShapeCore.customControllers.changeArcText(input, id);
                } else {
                    TextShapeCore.canvas.changeText(_settingsObject, input)
                }
            } else {
                TeamNamePanel.funcs.applyTextChanges(input, _settingsObject);
            }

            $(this).blur();
            $(this).removeClass("uk-form-warning");
            $(".team-name-helper-message").addClass("uk-hidden");
        }

        if (e.charCode == 8 || e.charCode == 0) {
            return null
        } else {
            return e.charCode >= 65 && e.charCode <= 90 || e.charCode >= 97 && e.charCode <= 122 || e.charCode === 32 || e.charCode === 45 
                || e.charCode >= 48 && e.charCode <= 57 // Allow Numbers (as per Sir.Kory)
        }
    },

    onLeaveTeamNameText: function() {
        var input = $(this).val().trim();
        var id = $(this).closest('#team-name-panel').data('code').toString();
        var _settingsObject = ub.funcs.getApplicationSettings(id);

        if (input.length === 0) {
            $("#team-name-panel .app-letters-input").val(_settingsObject.text);
            $(this).removeClass("uk-form-warning");
            $("#team-name-panel .team-name-helper-message").addClass("uk-hidden");
            return;
        }
        
        if (TextShapeCore.utilities.isTextShape(id)) {
            if (_settingsObject.text_shape_type === "arc") {
                TextShapeCore.customControllers.changeArcText(input, id);
            } else {
                TextShapeCore.canvas.changeText(_settingsObject, input)
            }
        } else {
            TeamNamePanel.funcs.applyTextChanges(input, _settingsObject);
        }

        $(this).removeClass("uk-form-warning");
        $("#team-name-panel .team-name-helper-message").addClass("uk-hidden");
    },

    onSelectTailSweep: function () {
        var code = $(this).closest(".teamOptionContainer").data("code");
        var settingsObj = ub.funcs.getApplicationSettings(code);
        var tailSweepSettingsObject = TailSweep.funcs.getTailSweepSettings(settingsObj.code);

        if ($(this).hasClass("uk-active")) {
            if (typeof tailSweepSettingsObject !== "undefined") {
                ub.funcs.activateMoveTool(tailSweepSettingsObject.code);
            }
            return;
        }

        var tailSweep = $(this).data("tail-sweep-name");

        if (TextShapeCore.utilities.isTextShape(settingsObj.code)) {
            if (tailSweep !== "none") {
                TextShapeCore.canvas.changeTextShape(settingsObj, TextShapeCore.TEXT_SHAPE_NONE, function() {
                    TailSweep.funcs.createTailSweepApplication(settingsObj, tailSweep, tailSweepSettingsObject);
                });
            } else {
                // Remove tailsweep
                ub.funcs.deleteLocation(tailSweepSettingsObject.code);
                settingsObj.hasTailSweeps = false;
            }
        } else {
            TailSweep.funcs.createTailSweepApplication(settingsObj, tailSweep, tailSweepSettingsObject);
        }
    
        $(".tail-sweep-container .tail-sweep-button.uk-active").removeClass("uk-active");
        $(this).addClass("uk-active");

        var tail = TailSweep.funcs.getTailSweepSettings(settingsObj.code);
        if (typeof tail !== "undefined") {
            TeamNamePanel.funcs.initializeTeamName(settingsObj.code, tail.code);
        }
    }
};

TeamNamePanel.funcs = {
    loadAddTeamName: function() {
        var renderTemplate = ub.utilities.buildTemplateString('#m-team-name-container', {
            hasCustomText: ub.funcs.isSocks() && ub.funcs.isKnitted() ? false : true
        });

        $('.modifier_main_container').html("");
        $('.modifier_main_container').html(renderTemplate);

        RichardsonOrderEditor.statusChecker(TeamNamePanel.funcs.disableTeamNameEditor, 100);
    },

    initializeTeamName: function(code, tailSweep) {
        var that = this;
        var teamNameObj = ub.funcs.getApplicationSettings(code);
        var _html;

        // Change Text Shape Model
        TextShapeCore.utilities.setTextShapeModel(TextShapeCore.TEAM_NAME_TYPE);

        if (teamNameObj.logo_type !== "custom_text") {
            var objStock = {
                application_type: teamNameObj.application_type,
                type: teamNameObj.application.name.toUpperCase(),
                defaultText: teamNameObj.text,
                code: teamNameObj.code,
                perspective: teamNameObj.application.views[0].perspective,
                hasAccents: true,
                accents: that.accent(teamNameObj),
                hasFontStyle: true,
                fontStyle: that.fontStyle(teamNameObj),
                hasTeamLayout: true,
                teamLayout: that.teamLayout(teamNameObj),
                hasColors: true,
                colorContainer: that.colorSelection(teamNameObj, "Team Name Colors"),
                hasFontSize: true,
                fontSizeSlider: that.fontSizeSlider(teamNameObj),
            };

            if (ub.config.sport.toLowerCase() === "baseball") {
                objStock.hasTailSweeps = true;
                objStock.tailSweepContainer = that.tailSweep(teamNameObj);
            }

            var tail = TailSweep.funcs.filterTailSweeps(teamNameObj.font_obj.alias);

            var _htmlBuilder = ub.utilities.buildTemplateString('#m-team-name-modifier-control', objStock);
            $(".modifier_main_container").html("");
            $(".modifier_main_container").html(_htmlBuilder);
            ub.funcs.initializer();

            if (!TailSweep.funcs.isAccentHasTailSweep(teamNameObj.accent_obj.code) || typeof tail === "undefined" || _.size(tail) === 0) {
                $(".team-name-panel .tail-sweep-container").hide();
            } else {
                $(".team-name-panel .tail-sweep-container").show();
            }

            if (teamNameObj.hasTailSweeps !== "undefined" && teamNameObj.hasTailSweeps) {
                var tailSweepSettingsObject = TailSweep.funcs.getTailSweepSettings(teamNameObj.code);
                if (typeof tailSweepSettingsObject !== "undefined") {
                    $(".team-name-panel .tail-sweep-container .tail-sweep-button[data-tail-sweep-name='"+ ub.utilities.titleCase(tailSweepSettingsObject.mascot.alias) +"']").addClass("uk-active");
                } else {
                    $(".team-name-panel .tail-sweep-container .tail-sweep-button[data-tail-sweep-name='none']").addClass("uk-active");
                }
            } else {
                $(".team-name-panel .tail-sweep-container .tail-sweep-button[data-tail-sweep-name='none']").addClass("uk-active");
            }
        } else {
            TeamNamePanel.funcs.renderCustomText(teamNameObj);
        }

        // Initialize application slider and move tool.
        ub.funcs.initializer();

        if (typeof tailSweep !== "undefined") {
            ub.funcs.activateMoveTool(tailSweep);
        } else {
            ub.funcs.activateMoveTool(teamNameObj.code);
        }

        // Change uniform perspective
        var primaryView = ub.funcs.getPrimaryView(teamNameObj.application);
        PerspectiveController.prototype.setPerspective(primaryView);

        // Disable Team name editor on completed orders
        RichardsonOrderEditor.statusChecker(TeamNamePanel.funcs.disableTeamNameEditor, 200);
    },

    renderCustomText: function(_settingsObject) {
        if (typeof _settingsObject.embellishment !== "undefined") {
            var designDetails = _settingsObject.embellishment.design_details;

            Inksoft.funcs.checkColorConflict(designDetails, function(hasConflict, colors) {
                if (hasConflict) {
                    var template = Inksoft.funcs.renderConflictingColors(colors, _settingsObject.code);
                    // Render Template
                    $(".modifier_main_container").html("");
                    $(".modifier_main_container").html(template);

                    $(".modifier_main_container .conflicting-colors-container").addClass("uk-padding-small");

                    Inksoft.funcs.initEvents();
                } else {
                    var template = document.getElementById("m-custom-text").innerHTML;
                    var objCustom = {
                        thumbnail: typeof _settingsObject.embellishment.thumbnail !== "undefined" ? _settingsObject.embellishment.thumbnail : _settingsObject.embellishment.png_filename,
                        application_type: _settingsObject.application_type,
                        logo_type: _settingsObject.logo_type.replace(/_/g, " "),
                        code: _settingsObject.code,
                        perspective: _settingsObject.application.views[0].perspective,
                        name: _settingsObject.embellishment.name,
                        viewArtDetails: ub.config.host + '/utilities/preview-logo-information/' + _settingsObject.embellishment.design_id,
                        viewPrint: _settingsObject.embellishment.svg_filename,
                        flip: ub.funcs.isFlippedApplication(_settingsObject.code) ? "uk-active" : "",
                        design_id: _settingsObject.embellishment.design_id,
                        isCustom: _settingsObject.logo_type === "custom" ? true: false
                    };
    
                    var renderTemplate = Mustache.render(template, objCustom);
                    $(".modifier_main_container").html("");
                    $(".modifier_main_container").html(renderTemplate);
                }
            });
        }

        MascotPanel.events.init();
    },

    accent: function(settingsObject) {
        var _accents = []
        _.map(ub.data.accents.items, function (accent) {
            var acc = {
                'thumbnail': '/images/sidebar/' + accent.thumbnail,
                'id': accent.id,
                'code': accent.code,
                'title': accent.code.replace(/_/g, " "),
                'active': settingsObject.accent_obj.id === accent.id ? 'uk-active' : '',
            }

            if (ub.funcs.isSocks() && ub.funcs.isKnitted()) {
                var validAccent = ["default", "outlined"];

                if (_.contains(validAccent, accent.code)) {
                    _accents.push(acc);
                }
            } else {
                _accents.push(acc);
            }
        })

        var templateData = {
            accents: _accents
        }

        var _htmlBuilder = ub.utilities.buildTemplateString('#m-team-name-accent', templateData);

        return _htmlBuilder;
    },

    fontStyle: function(settingsObject) {
        var templateData = {
            fontStyle: settingsObject.font_obj.name,
            fontCaption: settingsObject.font_obj.caption,
            code: settingsObject.code
        }

        var _htmlBuilder = ub.utilities.buildTemplateString('#m-team-name-font', templateData);
        return _htmlBuilder;
    },

    teamLayout: function(settingsObject) {
        var textShapeObject = TextShapeCore.utilities.findTextShape(TeamNamePanel.TEAM_NAME_TYPE);
        var text_shape_type = "none";

        if (textShapeObject) {
            text_shape_type = textShapeObject.text_shape_type;
        }

        var _htmlBuilder = ub.utilities.buildTemplateString('#m-team-name-layout', {
            team_name_layout: text_shape_type,
            team_name_layout_text: ub.utilities.titleCase(text_shape_type),
        });

        return _htmlBuilder;
    },

    changeTeamLayout: function(layout, application) {
        // Remove tailsweep if activated
        var hasTailSweep = TailSweep.funcs.getTailSweepSettings(application.code);
        
        if (hasTailSweep) {
            ub.funcs.deleteLocation(hasTailSweep.code);
            application.hasTailSweeps = false;
        }

        var layout_container_el = $('#team-name-layout-container');
        var team_name_layout_el = $('.select-team-name-layout .team-name-layout', layout_container_el);

        team_name_layout_el.data('team-name-layout', layout);
        team_name_layout_el.text(ub.utilities.titleCase(layout));

        if (layout === "arc") {
            TextShapeCore.customControllers.renderARC(application, "team_name", layout);
        } else {
            if (application.application_type !== TextShapeCore.TEXT_SHAPE_TYPE) {
                TextShapeCore.canvas.addTextShapeConfiguration(application, "team_name", layout);
            } else {
                TextShapeCore.canvas.changeTextShape(application, layout);
            }
        }

        TeamNamePanel.funcs.initializeTeamName(application.code);
    },

    colorSelection: function(_settingsObject, title) {
        var _colorBlock = '';
        var _html = '';

        _html += '<div class="colorSelectionContainer">';
        _html  += '<h6 class="uk-text-small uk-text-uppercase uk-text-bold uk-margin-top uk-margin-small-bottom abrade-black">'+title+'</h6>';
        _html += '<div class="uk-grid-small grid-tiny active-bgc-red" uk-switcher uk-grid>';

        _.each(_settingsObject.accent_obj.layers, function (layer, index) {
            // var _hexCode = layer.default_color;
            // var _color = ub.funcs.getColorObjByHexCode(_hexCode);
            if (layer.name === 'Mask' || layer.name === 'Pseudo Shadow') {
                return;
            }

            var _layerNo = layer.layer_no - 1;
            _color = _settingsObject.color_array[_layerNo];

            // Use default color if team color is short
            if (typeof _color === "undefined") {
                _hexCode = layer.default_color;
                _color = ub.funcs.getColorObjByHexCode(_hexCode);
                ub.utilities.error('Undefined color found here!!!');
            }

            if (typeof _color !== 'undefined') {
                if (index === 0) {
                    _html += '<div><button class="uk-width-1-1 padding-tiny-vertical uk-button-default uk-text-capitalize uk-button-small">' + layer.name + '</button></div>';
                } else {
                    _html += '<div class="uk-padding-remove"><button class="uk-width-1-1 padding-tiny-vertical uk-button-default uk-text-capitalize uk-button-small">' + layer.name + '</button></div>';
                }
                // building separated color blocks
                _colorBlock += TeamNamePanel.funcs.createColorBlock(_settingsObject.code, _color.color_code, layer.layer_no, layer.name, layer.default_color, 'accent');
            } else {
                util.error('Hex Code: ' + _hexCode + ' not found!');
            }
        });

        _html += '</div>';
        _html += '<ul class="uk-switcher uk-margin-small-top color-list-container">'
        _html += _colorBlock;
        _html += '</ul>';
        _html += '</div>';

        return _html;
    },

    createColorBlock: function(_id, activeColorCode, layer_no, layer_name, active_color, objectType) {
        var _html = '';
        var _teamColors = ub.data.secondaryColorPalette;
        var _objectType = objectType;

        if (typeof objectType === "undefined") {
            _objectType = 'not-set';
        }

        // Team name colors set to color pallete 5 (Hyper Twill Color) 
        if (ub.funcs.isSocks() && ub.funcs.isKnitted()) {
            _teamColors = ub.data.fifthColorPalette;
        }

        _teamColors = _.sortBy(_teamColors, "order");
        // _html += '<div id="tab-' + _id + '-' + layer_no + '" class="tab-pane fade cp-margin-remove" style="padding-bottom: 50px; padding-top: 20px;">';
        _html += '<li>'
        _html += '<div class="con-select con-palettes">'
        _html += '<div class="uk-grid-small grid-tiny uk-grid-match uk-child-width-auto uk-text-center m-palette-color" uk-grid>'
        _.each(_teamColors, function (_color) {
            var _checkMark = '';
            var _class = '';
            var _colorObj = ub.funcs.getColorByColorCode(_color.color_code);

            if (activeColorCode === _color.color_code) {
                _checkMark = '<span class="fa fa-check fa-1x cp-margin-remove cp-padding-remove cp-check-color-font-size" style="color:#' + _colorObj.forecolor + ';"></span>';
                _class = 'activeColorItem';
            }

            _html += '<div>';
            if (_colorObj.color_code === "W") {
                _html += '<button uk-tooltip="title:' + _colorObj.alias + '; pos: left;" class="uk-inline box-palette btn-selection-choice palette-color palette colorItem '+ _class +'" style="background-color:#ffff; color:#' + _colorObj.forecolor + ';" data-id="' + _id + '" data-layer-name="' + layer_name + '" data-color-code="' + _color.color_code + '" data-layer-no="' + layer_no + '" data-object-type="' + _objectType + '" data-color="'+_colorObj.hex_code+'">';
            } else {
                _html += '<button uk-tooltip="title:' + _colorObj.alias + '; pos: left;" class="uk-inline box-palette btn-selection-choice palette-color palette colorItem '+ _class +'" style="background-color:#' + _colorObj.hex_code + '; color:#' + _colorObj.forecolor + ';" data-id="' + _id + '" data-layer-name="' + layer_name + '" data-color-code="' + _color.color_code + '" data-layer-no="' + layer_no + '" data-object-type="' + _objectType + '" data-color="'+_colorObj.hex_code+'">';
            }
            _html += _checkMark;
            _html += '</button>';
            _html += '</div>';
        });

        _html += '</div>';
        _html += '</div>';
        _html += '</li>';

        return _html;
    },

    tailSweep: function(teamNameObj) {
        var fontObject = teamNameObj.font_obj;
        var templateData = {
            tailSweepsData: TailSweep.funcs.filterTailSweeps(fontObject.alias)
        }
        
        var _htmlBuilder = ub.utilities.buildTemplateString('#m-team-name-tailsweeps', templateData);

        return _htmlBuilder;
    },

    fontSizeSlider: function(_settingsObject) {
        var _htmlBuilder = ub.utilities.buildTemplateString('#m-team-name-font-size-slider', {code: _settingsObject.code});
        return _htmlBuilder;
    },

    newTeamName: function(type, no_alert) {
        var configuration = ub.funcs.isSocks() ? TeamNamePanel.configurationSocks: TeamNamePanel.configuration;
        var part;
        if (ub.funcs.isSocks()) {
            part = "Leg";
        } else {
            part = "Front Body";
        }

        var logo_type = type === "embellishments" ? "custom_text" : type;

        if (type === "team_name") {
            ApplicationCore.funcs.createNewTeamName(configuration.perspective, part, configuration.side, function(application) {
                TeamNamePanel.funcs.initializeTeamName(application.code);
            });
        } else if (type === "embellishments") {
            if (ub.config.isInksoftAvailable === "yes") {
                ApplicationCore.funcs.createNewEmbellishments(configuration.perspective, part, configuration.side, logo_type, part);
            } else {
                ub.utilities.notifyMe("Inksoft is currently under maintenance. Please try again later.", "danger");
            }
        }

        PerspectiveController.prototype.setPerspective(configuration.perspective);
    },

    setTeamNameToDefault: function() {
        var application = _.find(ub.current_material.settings.applications, {application_type: TeamNamePanel.TEAM_NAME_TYPE});

        var default_text = application.text;

        if (TextShapeCore.utilities.isTextShape(application.code)) {
            var textShape = TextShapeCore.utilities.findTextShape(TeamNamePanel.TEAM_NAME_TYPE);
            default_text = textShape.text;
        }

        $('.team-name-panel input.app-letters-input').val(default_text);
    },

    applyTextChanges: function(text, _settingsObject) {
        _settingsObject.text = text;

        if (text.length !== 0) {
            ApplicationCore.controllers.changeApplicationText(text, _settingsObject)
            return;
        } else {
            ApplicationCore.controllers.changeApplicationText(" ", _settingsObject)
            return;
        }
    },

    mapColorsToAccentObj: function() {
        var teamNameApp = _.find(ub.current_material.settings.applications, {application_type: TeamNamePanel.TEAM_NAME_TYPE});

        if (teamNameApp !== undefined) {
            var accentObjLayers = _.filter(teamNameApp.accent_obj.layers, function(layer) {
                return layer.name !== TeamNamePanel.LAYER_NAME_MASK && layer.name !== TeamNamePanel.LAYER_NAME_PSEUDO_SHADOW;
            });

            var accentObjColors = _.pluck(accentObjLayers, "default_color");
            var colorArray = _.pluck(teamNameApp.color_array, "hex_code");

            if (!_.isEqual(accentObjColors, colorArray)) {
                _.each(accentObjLayers, function(layer, index) {
                    layer.default_color = colorArray[index];
                });
            }
        }
    },

    addInputTextMessage: function(message) {
        $(".team-name-helper-message p").html("");
        $(".team-name-helper-message p").html(message);

        $(".team-name-helper-message").removeClass("uk-hidden");
    },

    disableTeamNameEditor: function() {
        var parent = $("div#team-name-panel");
        var disableClass = "uk-disabled";

        // Disable Remove
        $(".remove-team-name", parent).addClass(disableClass);
        // Disable Input Field
        $(".app-letters-input", parent).addClass(disableClass);
        // Font Selector
        $("#font-styles-container", parent).addClass(disableClass);
        // Layout Selector
        $("#team-name-layout-container", parent).addClass(disableClass);
        // Disable Slider
        $(".font-slider-container", parent).addClass(disableClass);
        // Disable Tail Sweep
        $(".tail-sweep-container", parent).addClass(disableClass);
        // Disable Accent Selector
        $(".m-accents", parent).addClass(disableClass);
        // Disable Color Selector
        $(".colorSelectionContainer .color-list-container", parent).addClass(disableClass);
        // For Custom Text
        $(".logo-details-container", parent).addClass(disableClass);
        // Add Team Name disable
        $(".add-team-name", parent).addClass(disableClass);
    }
};